// extracted by mini-css-extract-plugin
export default {"resize":"resize-FMCg","resizeMode":"resizeMode-ZICD"};